import { render, staticRenderFns } from "./MessageTimeDetail.vue?vue&type=template&id=2e7d1bf6&scoped=true&"
import script from "./MessageTimeDetail.vue?vue&type=script&lang=js&"
export * from "./MessageTimeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d1bf6",
  null
  
)

export default component.exports